document.querySelectorAll('form.cart').forEach(function(productForm) {
    class OptionSidebar {
        constructor(productForm) {
            //Переменные
            this.sidebar = productForm.querySelector('.options-sidebar');
            this.isNeedUpdateContent = true;
            this.product = productForm.classList.contains('variations_form') ? current_variation : JSON.parse(productForm.dataset.product);
            this.zarboOptions = {};
            this.filters = {};
            this.groups = new Map();
            this.options = new Map();
            this.variations = [];

            //Действия
            //Получить zarbo опции
            if (Object.keys(this.product['zarbo']).length ) {
                if (Object.keys(this.product['zarbo']['shaders']).length ) {
                    this.zarboOptions = this.product['zarbo']['shaders'];
                    if ('Ткань' in this.zarboOptions) delete this.zarboOptions['Ткани'];
                }
            }
            //Распарсить объект опций
            let optionObject = productForm.dataset.option_object;
            if (!optionObject) return;
            optionObject = JSON.parse(productForm.dataset.option_object);
            //Сформировать кеш групп
            optionObject['groups'].forEach(group => this.groups.set(group['id'], group));
            //Сформировать кеш опций
            optionObject['options'].forEach(option => this.options.set(option['id'], option));
            //Установить переменную вариаций
            this.variations = optionObject['variations'];
            //Установить активные вариации опций
            const variations = [];
            this.options.forEach(option => {
                if (option['type'] === 'required') {
                    const variation = this.variations.find(variation => variation['option_id'] === option['id']);
                    if (variation) variations.push(variation);
                }
            });
            this.setVariations(variations);

            //События
            //При смене вариации
            jQuery(productForm).on('show_variation', (event, variation) => {
                this.product = variation;
                //Получить zarbo опции
                if (Object.keys(this.product['zarbo']).length ) {
                    if (Object.keys(this.product['zarbo']['shaders']).length ) {
                        this.zarboOptions = this.product['zarbo']['shaders'];
                        if ('Ткань' in this.product['zarbo']['shaders']) delete this.zarboOptions['Ткани'];
                    }
                }
            });
            //Открыть сайдбар
            jQuery(productForm).on('click', 'a.options-trigger', event => {
                //Индекс группы
                const groupId = Number(event.currentTarget.dataset.groupId);
                //Сравнить id группы для открытия с последней открытой
                if (!('group' in this.filters)) this.filters['group'] = {};
                if (!('group_id' in this.filters['group']) || groupId !== this.filters['group']) {
                    //Меняем статус обновления контента
                    this.isNeedUpdateContent = true;
                    //Устанавливаем порядковый номер группы для фильтрации вариаций
                    this.filters['group']['group_id'] = groupId;
                }
                //Открыть оверлей
                jQuery(document.body).trigger('overlay_open');
                //Открыть сайдбар
                this.openSidebar();
            });
            //Закрыть сайдбар при закрытии оверлея
            jQuery(document.body).on('overlay_closed', () => this.closeSidebar());
            //Предвыбрать опцию без количества
            jQuery(this.sidebar).on('click', '.item:not([data-type="quantity"])', event => {
                this.preSelectVariation(event.currentTarget.dataset.id);
            });
            //Предвыбрать опцию с количеством
            jQuery(this.sidebar).on('change', 'input.qty-input', event => {
                this.preSelectVariation(event.currentTarget.closest('.item').dataset.id);
            });
            //Установить опцию с одним значением в группе
            jQuery(productForm).on('change', 'label.options-trigger input', event => {
                const id = Number(event.currentTarget.dataset.id);
                const variation = this.variations.find(variation => variation['id'] === id );

                let variations = current_options_variations;
                if (event.currentTarget.checked) {
                    if (!variations.some(variation => variation['id'] === id)) variations.push(variation);
                } else {
                    variations = variations.filter(variation => variation['id'] !== id);
                }

                this.setVariations(variations);
            });
            //Установить опцию
            jQuery(this.sidebar).on('click', '.options-sidebar-footer .button', event => {
                //Ничего не делаем, если кнопка не активна
                if (event.currentTarget.classList.contains('disabled')) return;
                //Установить значение
                const variations = current_options_variations
                    .filter(variation => variation['group_id'] !== this.filters['group']['group_id']);
                this.sidebar.querySelectorAll('.item.active').forEach(item => {
                    const variation = this.variations.find(variation => variation['id'] === Number(item.dataset.id));
                    const option = this.options.get(variation['option_id']);
                    if (option['type'] === 'quantity') variation['count'] = Number(item.querySelector('input.qty-input').value);
                    variations.push(variation);
                });
                this.setVariations(variations);
                //Закрываем сайдбар
                jQuery(document.body).trigger('overlay_close');
            });
        }

        openSidebar() {
            this.sidebar.classList.add('open');

            if (this.isNeedUpdateContent) this.updateContent();
        }

        closeSidebar() {
            this.sidebar.classList.remove('open');
        }

        updateContent() {
            //Меняем статус обновления контента
            this.isNeedUpdateContent = false;

            //Объект группы
            const group = this.groups.get(this.filters['group']['group_id']);

            //Заголовок сайдбара
            const top = this.sidebar.querySelector('.top');
            top.innerHTML = '';

            const title = document.createElement('span');
            title.classList.add('options-sidebar__title');
            title.innerHTML = group['title'];
            top.appendChild(title);

            //Отфильтровать варианты опций
            let options = this.filterItems(this.variations);

            //Формируем контентную область
            const content = this.sidebar.querySelector('.content');
            content.innerHTML = '';

            if (options.length) {
                //Сгруппировать опции
                options = this.groupItems(options);

                Object.keys(options).forEach(optionName => {
                    const option = this.options.get(options[optionName]['id']);

                    if (!option['is_title_hidden']) {
                        const subtitle = document.createElement('span');
                        subtitle.classList.add('options-sidebar__subtitle');
                        subtitle.innerHTML = optionName;
                        content.appendChild(subtitle);
                    }

                    const itemWrapper = document.createElement('div');
                    itemWrapper.classList.add('options-sidebar__content-wrapper');
                    if (!option['column_count'] || Number(option['column_count']) === 2) itemWrapper.classList.add('two-columns');
                    else if (Number(option['column_count']) === 4) itemWrapper.classList.add('four-columns');
                    content.appendChild(itemWrapper);

                    options[optionName]['items'].forEach(variation => {
                        const _variation = current_options_variations.find(_variation => _variation['id'] === variation['id']);

                        const item = document.createElement('div');
                        item.classList.add('options-sidebar__item');
                        item.classList.add('item');
                        if (_variation) item.classList.add('active');
                        item.dataset.id = variation['id'];
                        item.dataset.type = option['type'];
                        itemWrapper.appendChild(item);

                        const previewWrapper = document.createElement('div');
                        previewWrapper.classList.add('options-sidebar__image-wrapper');
                        item.appendChild(previewWrapper);

                        const preview = document.createElement('img');
                        preview.classList.add('options-sidebar__image');
                        preview.src = variation['preview_url'];
                        previewWrapper.appendChild(preview);

                        if (
                            option['zarbo']
                            && typeof this.zarboOptions === 'object' && Object.keys(this.zarboOptions).length
                            && typeof this.zarboOptions[option['zarbo']] === 'object' && Object.keys(this.zarboOptions[option['zarbo']]).length
                            && this.zarboOptions[option['zarbo']].includes(variation['title'])
                        ) {
                            const ar = document.createElement('div');
                            ar.classList.add('options-sidebar__ar');
                            ar.innerHTML = 'AR';
                            previewWrapper.appendChild(ar);
                        }

                        const title = document.createElement('span');
                        title.classList.add('options-sidebar__item-title');
                        title.innerHTML = variation['title'];
                        item.appendChild(title);

                        if (option['type'] === 'quantity') {
                            const count = _variation && 'count' in _variation ? _variation['count'] : 0;

                            let price = this.getVariationPrice(variation['id']);

                            const quantity = document.createElement('div');
                            quantity.classList.add('options-sidebar__qty');
                            quantity.classList.add('qty');
                            item.appendChild(quantity);

                            const quantityMinus = document.createElement('div');
                            quantityMinus.classList.add('options-sidebar__qty-minus');
                            quantityMinus.classList.add('qty-minus');
                            quantity.appendChild(quantityMinus);

                            const quantityWrapper = document.createElement('div');
                            quantityWrapper.classList.add('options-sidebar__qty-wrapper');
                            quantity.appendChild(quantityWrapper);

                            const quantityCount = document.createElement('span');
                            quantityCount.classList.add('options-sidebar__qty-count');
                            quantityCount.classList.add('qty-count');
                            quantityCount.innerHTML = count + ' шт.';
                            quantityWrapper.appendChild(quantityCount);

                            const quantityPrice = document.createElement('span');
                            quantityPrice.classList.add('options-sidebar__qty-price');
                            quantityPrice.classList.add('qty-price');
                            quantityPrice.innerHTML = price ? new Intl.NumberFormat('ru-RU').format(price) + ' ₽' : 'бесплатно';
                            quantityWrapper.appendChild(quantityPrice);

                            const quantityInput = document.createElement('input');
                            quantityInput.classList.add('options-sidebar__qty-input');
                            quantityInput.classList.add('qty-input');
                            quantityInput.min = 0;
                            quantityInput.value = count;
                            quantity.appendChild(quantityInput);

                            const quantityMax = document.createElement('div');
                            quantityMax.classList.add('options-sidebar__qty-plus');
                            quantityMax.classList.add('qty-plus');
                            quantity.appendChild(quantityMax);
                        } else {
                            let price = this.getVariationPrice(variation['id']);

                            const itemPrice = document.createElement('span');
                            itemPrice.classList.add('options-sidebar__price');
                            itemPrice.innerHTML = price ? new Intl.NumberFormat('ru-RU').format(price) + ' ₽' : 'бесплатно';
                            item.appendChild(itemPrice);
                        }

                        if (variation['description']) {
                            const description = document.createElement('span');
                            description.classList.add('options-sidebar__desc');
                            description.innerHTML = variation['description'];
                            item.appendChild(description);
                        }
                    })
                });
            }

            //Формируем футер сайдбара
            const footer = this.sidebar.querySelector('.options-sidebar-footer');
            footer.innerHTML = '';

            let _totalPrice = 0;
            this.variations.forEach(variation => {
                if (this.filters['groupID'] === variation['group_id']) {
                    _totalPrice += this.getVariationPrice(variation['id']);
                }
            });
            _totalPrice = _totalPrice ? new Intl.NumberFormat('ru-RU').format(_totalPrice) + ' ₽' : 'бесплатно';

            const totalPrice = document.createElement('span');
            totalPrice.classList.add('options-sidebar-footer__total');
            totalPrice.classList.add('total-price');
            totalPrice.innerHTML = _totalPrice;
            footer.appendChild(totalPrice);

            const button = document.createElement('a');
            button.classList.add('options-sidebar-footer__button');
            button.classList.add('button');
            button.classList.add('disabled');
            button.innerHTML = 'Применить';
            footer.appendChild(button);
        }

        filterItems(items) {
            return items.filter(item => item['group_id'] === this.filters['group']['group_id']);
        }

        groupItems(items) {
            const options = {};

            items.forEach(item => {
                const option = this.options.get(item['option_id']);
                if (option) {
                    const optionName = option['title'];

                    if  (!options[optionName]) {
                        options[optionName] = {
                            'id': item['option_id'],
                            'items': []
                        };
                    }

                    options[optionName]['items'].push(item);
                }
            });

            return options;
        }

        getVariationPrice(id, count = 1) {
            const variation = this.variations.find(variation => variation['id'] === Number(id));
            count = Number(count);

            let price = String(variation['price']);
            price = price.endsWith('%') ? (parseInt(price) / 100) * this.product['display_price'] : Number(price);
            return count ? price * count : price;
        }

        preSelectVariation(id) {
            id = Number(id);
            const variation = this.variations.find(variation => variation['id'] === id);
            const option = this.options.get(variation['option_id']);

            const variationItem = this.sidebar.querySelector('.item[data-id="' + id + '"]');
            if (option['type'] === 'required') {
                if (variationItem.classList.contains('active')) {
                    return;
                } else {
                    variationItem.parentNode.querySelector('.item.active').classList.remove('active');
                    variationItem.classList.add('active');
                }
            } else if (option['type'] === 'single') {
                if (variationItem.classList.contains('active')) {
                    variationItem.classList.remove('active');
                } else {
                    if (variationItem.parentNode.querySelector('.item.active')) {
                        variationItem.parentNode.querySelector('.item.active').classList.remove('active');
                    }
                    variationItem.classList.add('active');
                }
            } else if (option['type'] === 'multiple') {
                if (variationItem.classList.contains('active')) {
                    variationItem.classList.remove('active');
                } else {
                    variationItem.classList.add('active');
                }
            } else if (option['type'] === 'quantity') {
                const currentValue = Number(variationItem.querySelector('input.qty-input').value);

                const count = variationItem.querySelector('.qty-count');
                count.innerHTML = currentValue + ' шт.';

                currentValue > 0 ? variationItem.classList.add('active') : variationItem.classList.remove('active');
            }

            //Формируем футер сайдбара
            const footer = this.sidebar.querySelector('.options-sidebar-footer');
            footer.innerHTML = '';

            let _totalPrice = 0;
            this.sidebar.querySelectorAll('.content .item.active').forEach(variationItem => {
                const variationId = variationItem.dataset.id;
                const count = variationItem.dataset.type === 'quantity' ? variationItem.querySelector('.qty-input').value : 1;
                _totalPrice += this.getVariationPrice(variationId, count);
            });
            _totalPrice = _totalPrice ? new Intl.NumberFormat('ru-RU').format(_totalPrice) + ' ₽' : 'бесплатно';

            const totalPrice = document.createElement('span');
            totalPrice.classList.add('options-sidebar-footer__total');
            totalPrice.innerHTML = _totalPrice;
            footer.appendChild(totalPrice);

            let isButtonActive = false;
            Array.from(this.sidebar.querySelectorAll('.item')).some(item => {
                const id = Number(item.dataset.id);
                const variation = this.variations.find(variation => variation['id'] === id);
                const option = this.options.get(variation['option_id']);

                if (option['type'] === 'quantity') {
                    const currentValue = Number(item.querySelector('input.qty-input').value);
                    if (currentValue !== variation['value']) isButtonActive = true;
                } else {
                    if (item.classList.contains('active') !== variation['value']) isButtonActive = true;
                }
            });

            const button = document.createElement('a');
            button.classList.add('options-sidebar-footer__button');
            button.classList.add('button');
            if (!isButtonActive) button.classList.add('disabled');
            button.innerHTML = 'Применить';
            footer.appendChild(button);
        }

        setVariations(variations) {
            variations = variations.sort((a, b) => a['id'] - b['id']);

            const groups = [];
            const options = [];
            variations.forEach(variation => {
                if (!(groups.some(group => group['id'] === variation['group_id']))) groups.push(this.groups.get(variation['group_id']));
                if (!(options.some(option => option['id'] === variation['option_id']))) options.push(this.options.get(variation['option_id']));
            });

            jQuery(productForm).trigger('options_changed', [variations, groups, options]);
        }
    }

    if (productForm.classList.contains('variations_form')) {
        jQuery(productForm).one('show_variation', () => {
            new OptionSidebar(productForm);
        });
    } else {
        new OptionSidebar(productForm);
    }
});